<div cdkScrollable class="h-full overflow-auto">
  @if (hasAddButton()) {
    <div class="p-2 border-bottom">
      <a (click)="onAddCollection()" class="cursor-pointer flex items-center">
        <mat-icon class="mx-3">library_add</mat-icon>
        <span class="ml-3">
          {{ 'personal_content.buttons.add_collection' | transloco }} -
          {{ 'personal_content.collection_types.' + type | transloco }}
        </span>
      </a>
    </div>
  }

  @if (items.length === 0) {
    <div class="p-3 text-center">
      {{ (isFavorite() ? 'personal_content.messages.no_favorites' : 'personal_content.messages.no_collections') | transloco }}
    </div>
  }

  @if (isFavorite() || isTrashbin()) {
    @for (item of items; track item) {
      <div cdkScrollable class="border-bottom overflow-auto">
        <aipb-inside-loading [loading]="isLoading(item.id) | async"></aipb-inside-loading>
        <pc-shared-nibble-list
          (action)="onNibbleOpen($event)"
          (createEnded)="onNibbleCreate($event, item)"
          (deleteEnded)="init(item)"
          (editEnded)="onNibbleEdit($event, item)"
          (sortEnded)="init(item)"
          [collection]="item"
          [highlightId]="highlightNibbleId"
          [nibbles]="getNibbles(item) | async"
          context="plugin"
        ></pc-shared-nibble-list>
      </div>
    }
  }

  @if (!isFavorite() && !isTrashbin()) {
    @for (item of items; track item) {
      <div class="border-bottom">
        @if (!isFavorite() && !isTrashbin()) {
          <div class="flex items-center">
            <div class="p-2 mx-3">
              <pc-shared-nibble-type-icon [disabled]="!item.relations.ownedByCurrentUser" size="2x"
                                          type="COLL_CUSTOM"></pc-shared-nibble-type-icon>
            </div>
            <div (click)="onToggle($event, item)" class="min-w-0 cursor-pointer flex items-center p-2 flex-auto">
              <aipb-image [src]="item.thumb" height="50"></aipb-image>
              <div class="ml-2 w-full">
                @if (item.label) {
                  <div class="whitespace-nowrap overflow-hidden overflow-ellipsis item-label">
                    {{ item.label }}
                  </div>
                }
                @if (item.summary) {
                  <div
                    [style.max-width]="compact ? '300px' : '100%'"
                    class="mt-1 whitespace-nowrap overflow-hidden overflow-ellipsis"
                  >
                    {{ item.summary | truncate }}
                  </div>
                }
              </div>
            </div>
            <div class="flex items-center p-2">
              @if (compact) {
                <button [matMenuTriggerFor]="menu" mat-icon-button>
                  <mat-icon>more_vert</mat-icon>
                </button>
              }
              <mat-menu #menu="matMenu">
                <button (click)="onShowCollection(item.id)" mat-menu-item>
                  <mat-icon>edit</mat-icon>
                  Pokročilá práce s kolekcí
                </button>
                <mat-divider></mat-divider>
                <button (click)="onAddCollectionToFavorites(item)" mat-menu-item>
                  <mat-icon>content_copy</mat-icon>
                  Kopírovat do ...
                </button>
                <button (click)="onDeleteCollection(item)" [disabled]="!item.relations.ownedByCurrentUser"
                        mat-menu-item>
                  <mat-icon>delete</mat-icon>
                  Smazat kolekci
                </button>
              </mat-menu>
            </div>
          </div>
        }
        @if (compact && isCollectionVisible(item.id)) {
          <aipb-loading-progress [loading]="isLoading(item.id) | async"></aipb-loading-progress>
          @if (getCollection(item) | async; as collection) {
            <div
              [style]="
            'max-height: 410px;height:' +
            (collection.nibbles.length === 0 ? 160 : 100 * collection.nibbles.length + 60) +
            'px'
          "
              class="nibble-list-container"
            >
              <pc-shared-nibble-list
                (action)="onNibbleOpen($event)"
                (createEnded)="init(item)"
                (deleteEnded)="init(item)"
                (editEnded)="init(item)"
                (sortEnded)="init(item)"
                [collection]="collection"
                [nibbles]="collection.nibbles"
                context="plugin"
              ></pc-shared-nibble-list>
            </div>
          }
        }
      </div>
    }
  }
</div>
